import { useCurrentAgreement } from '@economic/react-app';
import { BadgeIcon, Select2, Tooltip } from '@economic/taco';
import { Trans, t } from '@lingui/macro';
import React from 'react';
import { PartialInvoiceDistributionType } from '~/types/internal-api';

interface Props {
    disabled?: boolean;
    showInfoAlert: boolean;
    defaultValue: PartialInvoiceDistributionType;
    onChange: (value: PartialInvoiceDistributionType) => void;
}

export default function DistributionTypeSelect({ disabled, showInfoAlert, defaultValue, onChange }: Props) {
    const agreement = useCurrentAgreement();
    return (
        <div className="w-56">
            <div className="font-bold mt-4 mb-2 flex items-center">
                <Trans>Choose distribution type</Trans>
                {!disabled && (
                    <Tooltip
                        hidden={showInfoAlert || !agreement.features.partialInvoicingLineBased}
                        title={t`You can now choose whether you want to create a partial invoice based on your product lines or based on an amount`}>
                        {!showInfoAlert && <BadgeIcon subtle small icon="info" className="ml-1" />}
                    </Tooltip>
                )}
            </div>
            <Tooltip
                hidden={!disabled}
                title={t`Change of distribution type not possible due to previous partial invoicing on this order`}>
                <Select2
                    id="select-distribution-type"
                    disabled={disabled}
                    defaultValue={defaultValue}
                    onChange={value => onChange(value as PartialInvoiceDistributionType)}>
                    <Select2.Option
                        value={PartialInvoiceDistributionType.ProductLineBased}>{t`Distribute by product lines`}</Select2.Option>
                    <Select2.Option value={PartialInvoiceDistributionType.AmountBased}>{t`Distribute by amount`}</Select2.Option>
                </Select2>
            </Tooltip>
        </div>
    );
}
